import React from 'react';
// import axios from 'axios';
import {get, post, put, del} from '../../DAL/Request'
import { Button, Form, Input, Row, Col, message } from 'antd';
import SubTitle from '../SubTitle'
import PicturesWall from './PicturesWall'
import config from '../../dummy_data/configuration.json';
import PropTypes from "prop-types";

const FormItem = Form.Item;
class FooterSetting extends React.Component {
	// static propTypes = {
	// 	item: PropTypes.object
	// }

	// static defaultProps = {
	// 	item: {
 //      		PhoneNumber1: "",
 //      		PhoneNumber2: "",
 //      		Fax: "",
 //      		Address1: "",
 //      		Address2: "",
 //      		Weibo: "",
 //      		Wechat: "",
 //      		QQ: ""
 //      	}
	// }
	static contextTypes = {
		router: PropTypes.object
	}

  	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    	fileList: [],
	    	item: {
	    		ID: "",
	      		PhoneNumber1: "",
	      		PhoneNumber2: "",
	      		Fax: "",
	      		Address1: "",
	      		Address2: "",
	      		Weibo: "",
	      		Wechat: "",
	      		QQ: "",
	      		QRCode: "",
	      		Created: '',
  				Modified: ''
	      	}
	    }
  	}

  	componentDidMount() {
  		this._refreshData();
  	}

  	handleImageChange = ({ fileList }) => {
		console.log(fileList);
		this.setState({ fileList });
		if(fileList.length > 0 && fileList[0].response !== undefined){
			let currentItem = this.state.item;
			currentItem.QRCode = config.rootSite + fileList[0].response;
			this.setState({ item: currentItem });
		}
	}
  	
  	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				console.log('Received values of form: ', values);

				values.ID = this.state.item.ID;
				values.QRCode = this.state.item.QRCode;
				values.Created = this.state.item.Created;
				values.Modified = this.state.item.Modified;

				// axios({
				// 	method: 'put',
				// 	url: config.footerAction,
				// 	responseType:'json',
				// 	data: values
				// }).then(res => {
				// 	console.log("response", res);
				// 	this._refreshData();
				// }).catch(function (error) {
				// 	console.log(error);
				// });
				put({
		  			url: config.footerAction, 
		  			history: this.context.router.history,
		  			body: values,
		  			callback: (res) => {
		  				console.log("response", res);
						this._refreshData();
						message.info('Succeeded');
		  			}
		  		});
			}
		});
	}

	_refreshData = () => {
		// axios.get(config.footerAction).then((res)=>{
  //           // console.log(res);
  //           this.setState({
  //           	item: res.data,
  //           	fileList: [{
		// 	      	uid: -1,
		// 	      	name: 'ttt.jpg',
		// 	      	status: 'done',
		// 			url: res.data.QRCode
		// 	    }]
  //           });
  //       }).catch((err)=>{
  //           console.log(err.status);
  //       })
        get({
  			url: config.footerAction, 
  			history: this.context.router.history,
  			callback: (res) => {
  				this.setState({
	            	item: res.data,
	            	fileList: [{
				      	uid: -1,
				      	name: 'ttt.jpg',
				      	status: 'done',
						url: res.data.QRCode
				    }]
	            });
  			}
  		});
	}

  	render() {
    	const { getFieldDecorator } = this.props.form;
    	const { PhoneNumber1, PhoneNumber2, Fax, Address1, Address2, Weibo, Wechat, QQ } = this.state.item;
	    return (
	      	<div>
		        <SubTitle title="Footer setting" />
		        <Form onSubmit={this.handleSubmit} className="footer-setting-form">
		        	<Row>
			        	<Col span={6} style={{ textAlign: 'left' }}>
			        		<FormItem label="Phone number 1">
								{
									getFieldDecorator(
										'PhoneNumber1', 
										{ initialValue: PhoneNumber1, rules: [{ required: true, message: 'Please input Phone number 1!' }],}
									)(
										<Input placeholder="Phone number 1" />
									)
								}
					        </FormItem>
			        	</Col>
			        	<Col span={3}></Col>
			        	<Col span={6} style={{ textAlign: 'left' }}>
			        		<FormItem label="Phone number 2">
								{
									getFieldDecorator(
										'PhoneNumber2', 
										{ initialValue: PhoneNumber2, rules: [{ required: false, message: 'Please input Phone number 2!' }],}
									)(
										<Input placeholder="Phone number 2" />
									)
								}
					        </FormItem>
			        	</Col>
			        	<Col span={3}></Col>
			        	<Col span={6} style={{ textAlign: 'left' }}>
			        		<FormItem label="Fax">
								{
									getFieldDecorator(
										'Fax', 
										{ initialValue: Fax, rules: [{ required: true, message: 'Please input Fax!' }],}
									)(
										<Input placeholder="Fax" />
									)
								}
					        </FormItem>
			        	</Col>
			        </Row>
			        <Row>
			        	<Col span={6} style={{ textAlign: 'left' }}>
			        		<FormItem label="Weibo">
								{
									getFieldDecorator(
										'Weibo', 
										{ initialValue: Weibo, rules: [{ required: false, message: 'Please input Weibo!' }],}
									)(
										<Input placeholder="Weibo" />
									)
								}
					        </FormItem>   
			        	</Col>
			        	<Col span={3}></Col>
			        	<Col span={6} style={{ textAlign: 'left' }}>
			        		<FormItem label="Wechat">
								{
									getFieldDecorator(
										'Wechat', 
										{ initialValue: Wechat, rules: [{ required: false, message: 'Please input Wechat!' }],}
									)(
										<Input placeholder="Wechat" />
									)
								}
					        </FormItem>
			        	</Col>
			        	<Col span={3}></Col>
			        	<Col span={6} style={{ textAlign: 'left' }}>
			        		<FormItem label="QQ">
								{
									getFieldDecorator(
										'QQ', 
										{ initialValue: QQ, rules: [{ required: false, message: 'Please input QQ!' }],}
									)(
										<Input placeholder="QQ" />
									)
								}
					        </FormItem>
			        	</Col>
			        </Row>       
			        <FormItem label="Email">
						{
							getFieldDecorator(
								'Address1', 
								{ initialValue: Address1, rules: [{ required: true, message: 'Please input Email!' }],}
							)(
								<Input placeholder="Email" />
							)
						}
			        </FormItem>
			        <FormItem label="Address">
						{
							getFieldDecorator(
								'Address2', 
								{ initialValue: Address2, rules: [{ required: true, message: 'Please input Address!' }],}
							)(
								<Input placeholder="Address" />
							)
						}
			        </FormItem>
			        
			        <FormItem label="QR code">
			          	<PicturesWall fileList={this.state.fileList} uploadAction={config.imageUploadAction} handleImageChange={this.handleImageChange}/>
			        </FormItem>
			        <FormItem wrapperCol={{ span: 2, offset: 22 }} className="form-submit">
			          	<Button type="primary" htmlType="submit">Submit</Button>
			        </FormItem>
		      	</Form>
	      	</div>
	    );
  	}
}

const FooterSettingForm = Form.create()(FooterSetting);

export default FooterSettingForm;


// WEBPACK FOOTER //
// ./src/components/admin/FooterSetting.js